'use client';

import { useEffect, useState } from 'react';
import { isValidLocale } from '@/shared/constants/locales';

/**
 * Client-side locale detection hook
 * Detects user's preferred locale from browser language.
 *
 * English is a valid answer here: a visitor whose browser asks for English
 * but who got a geo-derived locale (e.g. an IN IP → Hindi UI, the pre-fix
 * cookie) must be offered the way back. Skipping DEFAULT_LOCALE made that
 * suggestion impossible.
 */
export function useDetectedLocale(): string | null {
  const [detectedLocale, setDetectedLocale] = useState<string | null>(null);

  useEffect(() => {
    // Only detect on first render
    if (typeof window === 'undefined') {
      return;
    }

    // Check browser language
    const browserLanguages = navigator.languages || [navigator.language];
    for (const lang of browserLanguages) {
      const locale = lang?.split('-')[0]; // Get just the language code
      if (locale && isValidLocale(locale)) {
        setDetectedLocale(locale);
        return;
      }
    }
  }, []);

  return detectedLocale;
}
